/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import C4DContentItemCopy from '../content-item/content-item-copy';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import styles from './content-item-row.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The copy content of content item row with thumbnail.
 *
 * @element c4d-content-item-row-thumbnail-copy
 */
@customElement(`${c4dPrefix}-content-item-row-thumbnail-copy`)
class C4DContentItemRowThumbnailCopy extends StableSelectorMixin(
  C4DContentItemCopy
) {
  render() {
    return html` <slot></slot> `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--content-item-row-thumbnail-copy`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentItemRowThumbnailCopy;
